export default __webpack_public_path__ + "static/media/6.6932837f.jpg";